export default {
    'question': {
        display: {
            name: '提問',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'question',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-line-string',
            name: 'question'
        }
    },
    'answer': {
        display: {
            name: '回答',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'answer',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-line-string',
            name: 'answer'
        }
    },
    'updated_time': {
        display: {
            name: '最後更新日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'updated_time',
            data_type: 'datetime',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
}
  